const SetLang = () => {
  const langs = localStorage.getItem('langs')
  return JSON.parse(langs)
}
export default SetLang
export const UpdateLanguages = (languages, vv) => {
  languages = vv
}
